module.exports = __webpack_public_path__ + "img/paymentGroupIcon.f7d0a55e.png";